import { AgrimotorAddress } from "./address.model";
import { Claim } from "./claim.model";
import { Conviction } from "./conviction.model";
export class AgrimotorProposer {
    proposer_type: string = '';
    // Company fields
    micro_enterprise: string = '';
    company_name: string = '';
    trading_name: string = '';
    company_registration_number: string = '';
    year_established: string = '';
    // Individual fields
    title: string = '';
    first_name: string = '';
    last_name: string = '';
    dob: string = '';
    licence_type: string = '';
    licence_length: string = '';
    has_convictions: string = '';
    convictions: any = [];
    has_claims: string = '';
    claims: any = [];
    // Common fields
    address: any = new AgrimotorAddress();
    agricultural_trade: string = '';
    has_other_trades: string = '';
    contracting_percentage: string = '';
    business_purposes: string = '';
    is_phone: number = 0;
    sms: number = 0;
    is_email: number = 0;
    post: number = 0;
}
